module.exports = __webpack_public_path__ + "img/Motor_mob_2.798ff97e.jpg";